import algoliasearch from 'algoliasearch/lite';

import {
  InstantSearch,
  Hits,
  HierarchicalMenu,
  RefinementList,
  SearchBox,
  SortBy,
  Stats,
  Pagination,
  Panel,
  ClearRefinements,
  RatingMenu,
  RangeInput,
  Highlight,
  Configure,
  connectStateResults,
} from 'react-instantsearch-dom';

const searchClient = algoliasearch('6KMP52GB5X', 'a4bb5f7de85b6dc3b2313ece00f93394');

  export default function constructionType() {
  return (
    <InstantSearch searchClient={searchClient} indexName="Project_dev">
    <RefinementList attribute="material_type_names" />
          <Configure hitsPerPage={8} />
    
    </InstantSearch>
  );
}
